import { useState } from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    EmailIcon,
    LinkedinIcon,
    TelegramIcon,
} from 'react-share';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Copy, Check } from 'lucide-react';

const ShareBadgeDialog = ({ open, onOpenChange, shareUrl, title, description, name }) => {
    const [copied, setCopied] = useState(false);

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `${name} shared a badge`,
                    text: description || title,
                    url: shareUrl,
                });
            } catch (err) {
                if (err.name !== 'AbortError') console.error('Error sharing:', err);
            }
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md p-4 border border-neutral-300">
                <DialogHeader>
                    <DialogTitle>Share Badge</DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-4 py-4 px-2">
                    <div className="flex gap-3 justify-center flex-wrap">
                        <FacebookShareButton url={shareUrl} quote={title} blankTarget={true}>
                            <FacebookIcon size={40} round />
                        </FacebookShareButton>

                        <TwitterShareButton url={shareUrl} title={title} blankTarget={true}>
                            <TwitterIcon size={40} round />
                        </TwitterShareButton>

                        <WhatsappShareButton url={shareUrl} title={title} blankTarget={true}>
                            <WhatsappIcon size={40} round />
                        </WhatsappShareButton>

                        <LinkedinShareButton url={shareUrl} blankTarget={true}>
                            <LinkedinIcon size={40} round />
                        </LinkedinShareButton>

                        <TelegramShareButton url={shareUrl} title={title} blankTarget={true}>
                            <TelegramIcon size={40} round />
                        </TelegramShareButton>

                        <EmailShareButton
                            url={shareUrl}
                            subject={title}
                            body={description}
                            blankTarget={true}
                        >
                            <EmailIcon size={40} round />
                        </EmailShareButton>
                    </div>

                    <Button onClick={handleCopyLink} variant="outline" className="w-full">
                        {copied ? (
                            <>
                                <Check className="mr-2 h-4 w-4" />
                                Copied!
                            </>
                        ) : (
                            <>
                                <Copy className="mr-2 h-4 w-4" />
                                Copy Link
                            </>
                        )}
                    </Button>

                    {navigator.share && (
                        <Button onClick={handleNativeShare} variant="ghost" className="w-full">
                            More Options
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ShareBadgeDialog;
